import { render, staticRenderFns } from "./CategoryGrid.vue?vue&type=template&id=cb1a6452&scoped=true&"
import script from "./CategoryGrid.vue?vue&type=script&lang=js&"
export * from "./CategoryGrid.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGrid.vue?vue&type=style&index=0&id=cb1a6452&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a6452",
  null
  
)

export default component.exports